import { render, staticRenderFns } from "./AutoQueue.vue?vue&type=template&id=67cdc0d4&scoped=true"
import script from "./AutoQueue.vue?vue&type=script&lang=js"
export * from "./AutoQueue.vue?vue&type=script&lang=js"
import style0 from "./AutoQueue.vue?vue&type=style&index=0&id=67cdc0d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67cdc0d4",
  null
  
)

export default component.exports